import { PicturesUsage } from "@radarly/models/picture";
import { BlockedAuthors, Project, WeiboStatus } from "@radarly/models/project";
import { CreateProjectUser, SearchUser } from "@radarly/models/user";

export interface ProjectRepo {
  contactProjectManager(
    project: number,
    subject: string,
    content: string
  ): Promise<void>;
  getProject(project: number): Promise<Project>;
  getCurrentProject(): Project;
  generateProjectPictureUrl(project: number, picture: number): string;
  getProjectPicturesUsage: (projectId: number) => Promise<PicturesUsage>;
  getProjectBlockedAuthors(project: number): Promise<BlockedAuthors>;
  removeUser(project: number, userId: number): Promise<void>;
  removeUsers(
    project: number,
    usersId: number[]
  ): Promise<PromiseSettledResult<void>[]>;
  createProjectUser(
    project: number,
    user: CreateProjectUser
  ): Promise<{ user: Omit<SearchUser, "workspaces"> }>;
  getWeiboStatus(): Promise<WeiboStatus>;
}

export const ProjectRepositoryUID = Symbol("Radarly/ProjectRepository");
